import { Box, Icon, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { IoIosArrowDown } from 'react-icons/io'

export function InputInnovationSelect({ label, children, ...rest }) {
  const [openSelect, setOpenSelect] = useState(false)

  return (
    <Box
      border="1px solid #378BBF"
      borderRadius="4px"
      h="37px"
      display="flex"
      alignItems="center"
      position="relative"
      onClick={() => setOpenSelect(!openSelect)}
      cursor="pointer"
      bgColor="#fff"
      {...rest}
    >
      <Box
        color="#378BBF"
        mx="10px"
        textTransform="uppercase"
        fontSize="15px"
        fontWeight="semibold"
      >
        Cliente:
      </Box>
      <Text textTransform="uppercase">{label}</Text>
      <Icon
        as={IoIosArrowDown}
        position="absolute"
        right="10px"
        top="50%"
        transform={
          openSelect ? 'translateY(-50%) rotate(180deg)' : 'translateY(-50%)'
        }
        transition="transform 0.3s"
        color="#378BBF"
      />

      {openSelect && (
        <Box
          position="absolute"
          //stop propagação do evento de click
          onClick={(e) => e.stopPropagation()}
          cursor="default"
          top="100%"
          left="0"
          right="0"
          border={'1px solid #378BBF'}
          zIndex="1"
          bgColor="#fff"
          width="100%"
          overflow="hidden"
          transition="height 0.3s"
        >
          {children}
        </Box>
      )}
    </Box>
  )
}
